**Deprecated:** Use `seekRoleCode` instead.
